import { ChangeEvent } from 'react'
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  PathValue,
  UseFormSetValue,
} from 'react-hook-form'
import FormUrlPathInput, { FormUrlPathInputProps } from '../form-url-path-input'

type FormUrlPathInputRhfProps<TValues extends FieldValues, TName extends FieldPath<TValues>> = Omit<
  FormUrlPathInputProps,
  'name'
> &
  Omit<ControllerProps<TValues, TName>, 'render'> & { setValue: UseFormSetValue<TValues> }

const FormUrlPathInputRhf = <TValues extends FieldValues, TName extends FieldPath<TValues>>(
  props: FormUrlPathInputRhfProps<TValues, TName>,
) => {
  const { setValue, control, name, rules, ...restProps } = props

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    setValue(name, event.target.value as PathValue<TValues, TName>)

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <FormUrlPathInput {...restProps} value={field.value} onChange={handleChange} />
      )}
    />
  )
}

export default FormUrlPathInputRhf
